import { call } from './Methods'

export const use = {
  precisionRound: (number, precision) => {
    var factor = Math.pow(10, precision)
    return Math.round(number * factor) / factor
  },
  token: () => {
    return localStorage.getItem('tpp_token')
  },
  entryKey: async () => {
    let result = await call.user.checkToken(use.token())

    return use.token() ? result?.success : false
  },
  redirectToDashboard: async () => { },
  normalizePrecision: number => {
    return Math.round(number * 100) / 100
  },
  userSettings: () => {
    return JSON.parse(localStorage.getItem('tpp_userSettings'))
  },
  userShort: async () => {
    let userInfo = JSON.parse(sessionStorage.getItem('tpp_userInfo'))
    if (!userInfo) {
      let token = use.token()
      if (token) {
        const _userInfoRequest = await call.user.checkToken(token)
        if (_userInfoRequest.success) {
          userInfo = _userInfoRequest.data
        }
      }
    }
    return userInfo
  },
  getInputValueByName: (name, parent = document) => {
    console.log(name, parent)
    let element = parent.querySelectorAll(`body [name="${name}"]`)
    if (element.length === 1) {
      switch (element[0].type) {
        case 'checkbox':
          return Number(element[0].checked)
        default:
          return element[0].value || element[0].text
      }
    } else if (element.length > 1) {
      let valuesArray = []
      element.forEach(el => valuesArray.push(el.value))
      return valuesArray
    }
    return null
  },
  toggleFormInput: formId => { },
  convertUTCToLocalISOString(utcDate) {
    const utcTime = utcDate + 'Z'
    const date = new Date(utcTime);

    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear().toString().slice(-2) // Get last two digits of the year
    let hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    let period = 'AM'
    if (hours >= 12) {
      period = 'PM'
      if (hours > 12) hours -= 12
    } else if (hours === 0) {
      hours = 12
    }
    const formattedDateString = `${day}.${month}.${year} ${hours}:${minutes}${period}`
    return formattedDateString
  },
  resetUserLoginInfo: () => {
    localStorage.removeItem('tpp_token')
    sessionStorage.removeItem('tpp_userInfo')
  },
  colorsByValues:(value)=>{
    const colorsByValues = {
      '-2': '#E74C3C', // Crimson Red
      '-1': '#A9A9A9', // Dark Grey
      0: '#f3d500', // Vibrant Yellow
      1: '#0056A0', // Navy Blue
      2: '#9B30FF', // Deep Violet
      3: '#228B22', // Forest Green
      4: '#FF69B4', // Deep Golden Yellow
      5: '#69d200', // Chartreuse Green
      6: '#00AFFF', // Cyan Blue
      7: '#FF5733', // Coral Red
      8: '#E0E0E0', // Light Grey
      9: '#FFC200', // Hot Pink
    }
    return colorsByValues[value]
  }
}


